import { Charity, CharityMatchingSearch } from "reduxStore/services/api-v2/charities";
import { GlobalSettings } from "reduxStore/services/api-v2/globalSettings";

export const isHermesInboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return charity.postal_service.enabled && charity.postal_service.hermes_inbound_enabled && globalSettings.hermes_inbound_enabled;
};

export const isDhlInboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return charity.postal_service.enabled && charity.postal_service.dhl_inbound_enabled && globalSettings.dhl_inbound_enabled;
};

export const isInboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return isHermesInboundAvailable(charity, globalSettings) || isDhlInboundAvailable(charity, globalSettings);
};

export const isHermesOutboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return charity.postal_service.hermes_outbound_enabled && globalSettings.hermes_outbound_enabled;
};

export const isDhlOutboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return charity.postal_service.dhl_outbound_enabled && globalSettings.dhl_outbound_enabled;
};

export const isOutboundAvailable = (charity: Charity | CharityMatchingSearch, globalSettings?: GlobalSettings) => {
  if (!globalSettings) return false;
  return isHermesOutboundAvailable(charity, globalSettings) || isDhlOutboundAvailable(charity, globalSettings);
};